export function removeNonUTF8ASCII(str: string = '') {
    return str.replace(/[^\x00-\x7F]/g, '').trim();
}
